import React, { useState, useContext, useRef, useEffect, memo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { styles, navigateToCell } from "./shared.js";

export const RenderTradeEditable = memo(({
  row,
  rowCount,
  column,
  onCellInputBlur,
  TableContext,
  viewOnly,
}) => {
  const tradeReasonsData = useContext(TableContext);
  const { index, original } = row;
  const { id } = column;
  const currentTradeReason = original.tradeReason;
  const [optionListIsOpen, setOptionListIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(currentTradeReason);
  const selectTradeReasonRef = useRef(null);

  useEffect(() => {
    setSelectedValue(currentTradeReason);
  }, [currentTradeReason]);

  useEffect(() => {
    if (optionListIsOpen) {
      const optionList = document.querySelector(`[role="listbox"]`);
      if (optionList) {
        // Calculate the position of the listbox bottom relative to the viewport
        if (optionList.getBoundingClientRect().bottom > window.innerHeight) {
          optionList.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
      }
    }
  }, [optionListIsOpen]);

  return (
    <div>
      <div style={{ marginBottom: "3px" }}>
        <Select
          ref={selectTradeReasonRef}
          placeholder={"Select..."}
          value={
            selectedValue ? { label: selectedValue, value: selectedValue } : null
          }
          tabIndex={-1}
          id={`${id}-${index}`}
          options={tradeReasonsData.tradeReasons.map((member) => ({
            label: member.code,
            value: member.code,
          }))}
          isDisabled={viewOnly}
          myFontSize="5px"
          styles={styles}
          onMenuOpen={() => setOptionListIsOpen(true)}
          onMenuClose={() => setOptionListIsOpen(false)}
          onChange={(e) => {
            setSelectedValue(e.value);
            onCellInputBlur(e.value, index, id, row);
          }}
          onKeyDown={(e) => {
            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
              e.preventDefault();
              navigateToCell(id, index, e.key, rowCount);
            }
          }}
        />
      </div>
    </div>
  );
});

RenderTradeEditable.displayName = "RenderTradeEditable";

RenderTradeEditable.propTypes = {
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
    original: PropTypes.shape({
      tradeReason: PropTypes.string,
    }).isRequired,
  }).isRequired,
  rowCount: PropTypes.number.isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCellInputBlur: PropTypes.func.isRequired,
  TableContext: PropTypes.object.isRequired,
  viewOnly: PropTypes.bool.isRequired,
};
